import styled from 'styled-components';

export const Svg = styled.svg`
  display: inline-block;
  vertical-align: middle;
  margin: 0 10px;

  & path {
    fill: ${({ color, theme }) => color || theme.primaryColor};
  }
`;

export default Svg;



// WEBPACK FOOTER //
// ./src/views/common/components/Icon/styled-components.js